/**
 * WidgetSkeleton — shared loading/error filler for BUILTIN widget Hosts.
 * height:100% so the grid cell keeps its footprint (design brief: "cells
 * never collapse"). variant='error' is a silent-degrade inline message —
 * matches how PortfolioDashboardPage/AccountDashboardPage already treat
 * capacity/bottleneck fetch failures today (non-fatal, empty-array
 * fallback); WidgetBoundary (a sibling wrapper, not this component) owns
 * the separate render-crash fallback.
 */
export function WidgetSkeleton({ variant = 'loading', label }: { variant?: 'loading' | 'error'; label?: string }) {
  if (variant === 'error') {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--surface-1)',
          borderRadius: 'var(--radius-panel)',
          boxSizing: 'border-box',
        }}
      >
        <span style={{ fontFamily: 'var(--font-sans)', fontSize: 13, color: 'var(--text-low)' }}>
          {label ? `${label} couldn't load.` : "Couldn't load."}
        </span>
      </div>
    );
  }
  return <div className="skeleton" style={{ height: '100%', minHeight: 80, borderRadius: 'var(--radius-panel)' }} />;
}
